import { declineEventAndAddMessage } from 'owa-locstrings/lib/strings/declineeventandaddmessage.locstring.json';
import { tentativelyAcceptEventAndAddMessage } from 'owa-locstrings/lib/strings/tentativelyaccepteventandaddmessage.locstring.json';
import { proposeNewTimeAndAddMessage } from 'owa-locstrings/lib/strings/proposenewtimeandaddmessage.locstring.json';
import loc from 'owa-localize';

import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import type ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export default function getProposeNewTimeMenuItems(
    item: CalendarEvent,
    proposeNewTimesHandler: (editorTitle: string, responseType: ResponseTypeType) => void
): IContextualMenuItem[] {
    const allowTentativelyAccept = !(item.ResponseType === 'Decline');

    return [
        {
            key: 'tentative_and_propose_new_time',
            name: loc(tentativelyAcceptEventAndAddMessage),
            onClick: () => {
                proposeNewTimesHandler(loc(proposeNewTimeAndAddMessage), 'Tentative');
            },
            disabled: !allowTentativelyAccept,
        },
        {
            key: 'decline_and_propose_new_time',
            name: loc(declineEventAndAddMessage),
            onClick: () => {
                proposeNewTimesHandler(loc(proposeNewTimeAndAddMessage), 'Decline');
            },
        },
    ];
}
